// extracted by mini-css-extract-plugin
export default {"gallery":"c-p_fx","gallery__header":"c-p_fy","gallery__thumbs":"c-p_fz"};